
import {initWebComponent} from "@/helpers/web-component-helper";
import {getAnimationDuration, zoomOut} from "@/helpers/ol/ol-event-helper";
import {OlZoomInComponent} from "@/components/ol/buttons/ol-zoom-in-component";
import {OlDrawGeometryComponent} from "@/components/ol/buttons/ol-draw-geometry-component";
import {OlDrawGeometryTypeComponent} from "@/components/ol/buttons/ol-draw-geometry-type-component";
import {
    getBySelector,
    hideElementsBySelector,
    isVisibleBySelector,
    showElementsBySelector
} from "@/helpers/element-helper.js";

const template = document.createElement('template');
template.innerHTML = `<footer-button data-title="Wissel van achtergrondkaart" data-icon="fa fa-map"></footer-button>`;

export class OlMapSwitcherComponent extends HTMLElement {
    constructor(){
        super();
        initWebComponent(this, template)

        this.addEventListener('click', () => {
            if (isVisibleBySelector('layer-menu-compare')) {
                hideElementsBySelector('layer-menu-compare');
                this.firstChild.firstChild.classList.remove('active');
            }

            if (getBySelector('.ol-control-small').classList.contains('d-none')) {
                showElementsBySelector('.ol-control-small');
                showElementsBySelector('#divBackgroundSwitcher');
                showElementsBySelector('ol-background-switcher');
            } else {
                hideElementsBySelector('.ol-control-small');
                hideElementsBySelector('ol-background-switcher');
                hideElementsBySelector('#divBackgroundSwitcher');
            }
        });
    }
}